import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { handleOnClick } from '../../../../../../utils';
var ActionDropdownItem = function ActionDropdownItem(_ref) {
  var content = _ref.content,
    iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(DropdownItem, {
    elemAfter: iconAfter,
    elemBefore: iconBefore,
    isDisabled: isLoading,
    onClick: handleOnClick(onClick),
    testId: testId
  }, content);
};
export default ActionDropdownItem;